module.exports = __webpack_public_path__ + "static/media/bigcash_logo.dc3e3b5d.svg";